import React from 'react';
import { Button, Container, Text, Title } from '@mantine/core';
import type { IErrorBoundaryProps, IErrorBoundaryState } from './types';
import classes from './ErrorBoundary.module.css';

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): IErrorBoundaryState {
    return { hasError: true, error };
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <Container className={classes.root}>
          <Title className={classes.title}>Something went wrong</Title>
          <Text c="dimmed" size="lg" ta="center" className={classes.description}>
            An unexpected error occurred. Please try refreshing the page.
          </Text>
          <Button variant="subtle" size="md" onClick={(): void => globalThis.location.reload()}>
            Refresh Page
          </Button>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
